enum BusinessType {
  Leasing = 'leasing',
  Retail = 'retail',
}

export default BusinessType;
